import { useEffect, useRef, useState } from 'react';

export function useStateRef<S>(init: S) {
  const [data, setData] = useState(init);
  const dataRef = useRef(init);

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  return [data, setData, dataRef] as [S, typeof setData, typeof dataRef];
}
